export default function verifyLogin(history) {
    if (!localStorage.getItem('checkinToken')) {
        history.push('/login');
    }
}